import IRegionHwrc from "interfaces/models/IRegionHwrc";
import IClaimHwrc from "interfaces/responses/IClaimHwrc";

const mapClaimToRegion = (claim : IClaimHwrc) : IRegionHwrc => {
  const region : IRegionHwrc = {
    regionId: claim.id,
    regionName: claim.displayName
  };

  return region;
};

export { mapClaimToRegion };
